import React,{ useState,useEffect,useRef } from 'react';
import { Link }                            from 'react-router-dom';                   
import { useSelector,useDispatch }         from 'react-redux';
// import moment                              from 'moment';
import { Helmet }                          from 'react-helmet';
//MATERIAL UI
import CircularProgress                    from '@mui/material/CircularProgress';
import Box                                 from '@mui/material/Box';
import Grid                                from '@mui/material/Grid2';
import Typography                          from '@mui/material/Typography';
import Autocomplete                        from '@mui/material/Autocomplete';
import IconButton                          from '@mui/material/IconButton';
import Dialog                              from '@mui/material/Dialog';
import Stack                               from '@mui/material/Stack';
import Breadcrumbs                         from '@mui/material/Breadcrumbs';
import Button                              from '@mui/material/Button';
import TextField                           from '@mui/material/TextField';
import InputAdornment                      from '@mui/material/InputAdornment';
import { LocalizationProvider }            from '@mui/x-date-pickers';
import { AdapterMoment }                   from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker }                      from '@mui/x-date-pickers/DatePicker';
import { styled }                          from '@mui/material/styles';
// MATERIAL ICONS
import CallMadeIcon                        from '@mui/icons-material/CallMade';
import CloseIcon                           from '@mui/icons-material/Close';
import AttachFileIcon                      from '@mui/icons-material/AttachFile';
import ChevronRight                        from '@mui/icons-material/ChevronRight';
//ACTIONS
import { addUpdate,getCommonDrop,careerAddUpdate } from '../../redux/actions/common';
import { readFile,imageExist }                     from '../js/init';
 
export const Spinner=()=>{
	return (
		<Grid container>
			<Grid size={12} sx={{ display:'flex',justifyContent:'center',alignItems:'center',height:'100vh' }}>
				<CircularProgress />
			</Grid>
		</Grid>
	);
};

//CUSTOM UPLOAD BUTTON
const VisuallyHiddenInput = styled('input')({
	clip       : 'rect(0 0 0 0)',
	clipPath   : 'inset(50%)',
	height     : 1,
	overflow   : 'hidden',
	position   : 'absolute',
	bottom     : 0,
	left       : 0,
	whiteSpace : 'nowrap',
	width      : 1
});

// CUSTOM DATEPICKER
//not used in forms , use incase wants datepicker
export function CustomDatePicker(props){

	//-------------------------------------------//
	//------------ USE STATE - START ------------//
	//-------------------------------------------//

	const [dateOpen,setDateOpen] = useState(false);
	const [openTo,setOpenTo]     = useState(props.openTo);

	//-----------------------------------------//
	//------------ USE STATE - END ------------//
	//-----------------------------------------//
    
	//--------------------------------------------//
	//------------ USE EFFECT - START ------------//
	//--------------------------------------------//

	useEffect(()=>{ // SET VALUE TO STATE
		setOpenTo(props.openTo);
	},[props.openTo]);

	//--------------------------------------------//
	//------------ USE EFFECT - END---------------//
	//--------------------------------------------//

	//------------------------------------------//
	//------ FUNCTION & ONCHANGE - START -------//
	//------------------------------------------// 

	// ON CLOSE MENU
	const closeMenu=()=>{
		if(props.value){
			setOpenTo(null);
		}
		setDateOpen(false);
	};

	// ON OPEN MENU
	const openMenu=()=>{
		if(props.value){
			setOpenTo(null);
		}else{
			setOpenTo(props.openTo);
		}
		setDateOpen(!dateOpen);
	};

	//------------------------------------------//
	//------ FUNCTION & ONCHANGE - END----------//
	//------------------------------------------//

	return(
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DatePicker
				{...props}
				open      = {dateOpen}
				onClose   = {()=>closeMenu()}
				// onClose   = {()=>setDateOpen(false)}
				openTo    = {openTo}
				// openTo    = {props.openTo}
				views     = {props.views ? props.views : ['year', 'month', 'day']}
				format    = {props.views ? null : 'DD-MM-YYYY'}
				slotProps = {{
					field     : { clearable:true },
					textField : {
						required   : props.required,
						variant    : props.variant ? props.variant : 'standard',
						fullWidth  : true,
						name       : props.name,
						label      : props.label ? props.label : '',
						helperText : props.helperText,
						error      : props.error,
						onClick    : props.disabled?null:()=>openMenu(),
						// onClick    : props.disabled?null:()=>setDateOpen(!dateOpen),
						size       : props.size,
						InputProps : props.InputProps,
						sx         : props.sx,
						InputLabelProps : { shrink:true }
					}
				}}
			/>
		</LocalizationProvider>
	);
}

export const SimpleForm = (props) => {

	//-----------------------------------------//
	//------------ USE REF - START ------------//
	//-----------------------------------------//

	const pgRef = useRef({
		api : {
			cafsIndia : '/cafs_india'
		},
		apiCall : {
			dropSts  : false
		}
	});
	const counterSts = useRef(false);

	//---------------------------------------//
	//------------ USE REF - END ------------//
	//---------------------------------------//

	//-------------------------------------------//
	//------------ USE STATE - START ------------//
	//-------------------------------------------//

	const [pageInfo,setPageInfo] = useState({
		formError : {},
		formData  : {
			name   : '',
			mobile : '',
			age    : ''
		},
		formLoad  : false,
		showModal : props.open,
		showForm  : true,
		counter   : { seconds:10 }
	}); 

	//-----------------------------------------//
	//------------ USE STATE - END ------------//
	//-----------------------------------------//

	//---------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - START ------------//
	//---------------------------------------------------------------//

	const dispatch = useDispatch();
	const apiRes   = useSelector((state) => {
		return { 
			data : {
				addUpdate : state.reducer.addUpdate
			}
		};
	});
	
	//-------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - END ------------//
	//-------------------------------------------------------------//

	//--------------------------------------------//
	//------------ USE EFFECT - START ------------//
	//--------------------------------------------//

	//SCROLL TO TOP
	useEffect(() => {
		window.scrollTo(0, 0); 
	}, []); 

	//GET LOCAL STORAGE DATA 
	useEffect(()=>{
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,showModal:props.open }));
		const storedData = localStorage.getItem('contactData');
		if(storedData){
			let formData = JSON.parse(storedData);
			setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formData }));
		}
	},[props.open]);

	//ADD UPDATE
	useEffect(()=>{
		if(pgRef.current.apiCall.addUpd){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:false };
			let addInfo           = apiRes.data.addUpdate;
			if(addInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad  : false,
					formData  : {},
					formError : {},
					showForm  : false,
					counter   : { seconds:10 }
				}));
				counterSts.current = true;
			}else{
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad:false,
					formError:addInfo.error
				}));
				counterSts.current = false;
			}
		}
	},[apiRes.data.addUpdate]);

	// COUNTDOWN
	useEffect(() => {
		if(counterSts.current){
			const myInterval = setInterval(() => {
				const { seconds } = pageInfo.counter;
				if(seconds > 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						counter : { ...prevPageInfo.counter,
							seconds : seconds - 1
						}
					}));
				}
				if(seconds === 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						showForm:true
					}));
					clearInterval(myInterval);
					const storedData = localStorage.getItem('contactData');
					if(storedData){
						let formData = JSON.parse(storedData);
						setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formData }));
					}
				}
			}, 1000);
			return () => clearInterval(myInterval);
		}
	}, [pageInfo.counter.seconds,pageInfo.showForm,pageInfo.counter]);

	//--------------------------------------------//
	//------------ USE EFFECT - END---------------//
	//--------------------------------------------//

   
	// MODAL CLOSE
	const handleModalClose = () => {
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,showModal:false,formError:{},formData:{} }));
		if(props.onCloseDialog){
			props.onCloseDialog(false); 
		}
	};

	//INPUT CHANGE 
	const hadleChange = (event,proFor) => {
		let formdata = { ...pageInfo.formData };
		if(proFor === 'mobile'){
			let value = event.target.value;
			if(/^\d{0,10}$/.test(value)) {
				formdata[String(proFor)] = value;
			}
		}else if(proFor === 'age'){
			let value = event.target.value;
			if(/^\d{0,2}$/.test(value)) {
				formdata[String(proFor)] = value;
			}
		}else{
			let value = event.target.value;
			formdata[String(proFor)] = value;
		}
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formdata,formError:{} }));
	};

	//SUBMIT FORM
	const handleSubmit = (event) => {
		event.preventDefault();
		let frmData = { ...pageInfo.formData };
		frmData['pro_mode']  = 'ADD';
		frmData['form_mode'] = '6814a9fa5daa8c390835805d';
		dispatch(addUpdate({ sendTo:pgRef.current.api.cafsIndia,formData:frmData }));
		pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:true };
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formLoad:true }));
		localStorage.setItem('contactData', JSON.stringify(pageInfo.formData));
	};

	//SUCCESS OR ERROR MESSEGE BACK
	const onBack=()=>{
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
			showForm:true
		}));
		const storedData = localStorage.getItem('contactData');
		if(storedData){
			let formData = JSON.parse(storedData);
			setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formData }));
		}
	};

	return (
		<Dialog
			open       = {pageInfo.showModal}
			maxWidth   = "sm"
			onClose    = {handleModalClose}
			fullWidth
			PaperProps = {{ sx: { borderRadius: '20px' } }}
		>
			<Grid container rowSpacing={2} className="simple_form_container">   
				<Grid className="career_form_cancel_btn">
					<IconButton onClick={handleModalClose}><CloseIcon sx={{ fontSize:'25px !important',color:'#cfcfcf' }}/></IconButton>
				</Grid>
				<Grid size={12}>
					<Grid container>
						<Grid size={12}>
							<Typography  className="blue_cl custom_h1 font_weight_medium">
								Reach Out for Financial <span className='orange_cl custom_h1 font_weight_medium'>Solutions !</span> 
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={12} mb={'30px'}>
					{pageInfo.showForm ?
						<Grid container spacing={2} rowSpacing={4} component="form" id="simple_form">
							<Grid size={{ md:6,xs:12 }}>
								<TextField 
									required 
									onChange	 = {(e)=>hadleChange(e,'name')} 
									disabled	 = {pageInfo.formLoad}
									helperText	 = {pageInfo.formError.name?pageInfo.formError.name:''}
									value		 = {pageInfo.formData.name?pageInfo.formData.name:''}
									error		 = {pageInfo.formError.name}
									label		 = "Your Name"
									autoComplete = 'off'
									sx			 = {{
										'& .MuiFormHelperText-root': {
											fontSize: '13px !important'
										}
									}}
								/>
							</Grid>
							<Grid size={{ md:6,xs:12 }}>
								<TextField 
									onChange	 = {(e)=>hadleChange(e,'email')} 
									disabled	 = {pageInfo.formLoad}
									helperText	 = {pageInfo.formError.email?pageInfo.formError.email:''}
									value		 = {pageInfo.formData.email?pageInfo.formData.email:''}
									error		 = {pageInfo.formError.email}
									label		 = "Your Email"
									autoComplete = 'off'
								/>
							</Grid>
							<Grid size={{ md:6,xs:12 }}>
								<TextField 
									required 
									onChange	 = {(e)=>hadleChange(e,'mobile')} 
									disabled	 = {pageInfo.formLoad}
									helperText	 = {pageInfo.formError.mobile?pageInfo.formError.mobile:''}
									value		 = {pageInfo.formData.mobile?pageInfo.formData.mobile:''}
									error		 = {pageInfo.formError.mobile}
									label		 = "Contact"
									autoComplete = 'off'
									sx			 = {{
										'& .MuiFormHelperText-root': {
											fontSize: '13px !important'
										}
									}}
									slotProps	 = {{
										input: {
											endAdornment: <InputAdornment position="start">
												{pageInfo.formData.mobile?pageInfo.formData.mobile.length:0}/10
											</InputAdornment>
										}
									}}
								/>
							</Grid>
							<Grid size={{ md:6,xs:12 }}>
								<TextField
									required
									onChange	 = {(e)=>hadleChange(e,'age')}
									disabled	 = {pageInfo.formLoad}
									helperText	 = {pageInfo.formError.age?pageInfo.formError.age:''}
									value		 = {pageInfo.formData.age?pageInfo.formData.age:''}
									error		 = {pageInfo.formError.age}
									label		 = "Your Age"
									autoComplete = 'off'
									sx			 = {{
										'& .MuiFormHelperText-root': {
											fontSize: '13px !important'
										}
									}}
								/>
							</Grid>
						</Grid>
						:
						<Grid container spacing={2}>
							<Grid size={12} textAlign="center">
								{imageExist({
									required  : '/common',
									url       : '/splash.gif',
									alt       : 'splash',
									height    : '100px mb_25'
								})}
								<h3 className='mb_15 orange_cl'>Your request has been <span className='blue_cl'>submitted</span> successfully!!!</h3>
								<p className='mb_10'>Your information has been successfully received. We will review your submission and get back to you as soon as possible.</p>
								<p className='mb_15 gray_cl font_14'>Back to form in <span className='mb_15 orange_cl'>{pageInfo.counter.seconds} seconds</span></p>
								<Button variant="contained" color="primary" className='btn_submit_form' loadingPosition='end' onClick={onBack}>Back</Button>
							</Grid>
						</Grid>
					}
				</Grid>
				{pageInfo.showForm ?
					<Grid size={12} sx={{ textAlign:'right' }}>
						<Button className='btn_blue_white' color='secondary' type='submit' form={'simple_form'} loading={pageInfo.formLoad} loadingPosition='start' onClick={handleSubmit} startIcon={<CallMadeIcon/>}>Submit</Button>
					</Grid>
					:''
				}
			</Grid>
		</Dialog>
	);
};

export const BasicForm = (props) => {

	//-----------------------------------------//
	//------------ USE REF - START ------------//
	//-----------------------------------------//

	const pgRef = useRef({
		api : {
			cafsIndia  : '/cafs_india'
		},
		apiCall : {
			initCall : true,
			dropSts  : false
		}
	});
	const counterSts = useRef(false);

	//---------------------------------------//
	//------------ USE REF - END ------------//
	//---------------------------------------//

	//-------------------------------------------//
	//------------ USE STATE - START ------------//
	//-------------------------------------------//

	const [pageInfo,setPageInfo] = useState({
		formId    : props.proFrom,
		dropData  : {},
		formError : {},
		formData  : {
			name   : '',
			age    : '',
			mobile : ''
		},
		formLoad  : false,
		showForm  : true,
		counter   : { seconds:10 }
	});

	//-----------------------------------------//
	//------------ USE STATE - END ------------//
	//-----------------------------------------//

	//---------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - START ------------//
	//---------------------------------------------------------------//

	const dispatch = useDispatch();
	const apiRes   = useSelector((state) => {
		return { 
			data : {
				commonDropDown : state.reducer.commonDropDown,
				addUpdate      : state.reducer.addUpdate
			}
		};
	});

	//-------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - END ------------//
	//-------------------------------------------------------------//

	//--------------------------------------------//
	//------------ USE EFFECT - START ------------//
	//--------------------------------------------//

	// INIT CALL
	useEffect(()=>{ 
		(async()=>{
			if(pgRef.current.apiCall.initCall){
				dispatch(getCommonDrop({ sendTo:pgRef.current.api.cafsIndia }));
				pgRef.current.apiCall = await { ...pgRef.current.apiCall,initCall:false,dropSts:true };
			}
		})();
	},[dispatch]);

	//DROPDOWN
	useEffect(()=>{
		if(pgRef.current.apiCall.dropSts){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,dropSts:false };
			let dropInfo          = apiRes.data.commonDropDown;
			if(dropInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,dropData:dropInfo.rslt }));
				const storedData = localStorage.getItem('userData');
				if(storedData){
					let formData = JSON.parse(storedData);
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formData }));
				}
			}
		}
	},[apiRes.data.commonDropDown]);

	//ADD UPDATE
	useEffect(()=>{
		if(pgRef.current.apiCall.addUpd){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:false };
			let addInfo           = apiRes.data.addUpdate;
			if(addInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad  : false,
					formData  : {},
					formError : {},
					showModal : false,
					showForm  : false,
					counter   : { seconds:10 }
				}));
				counterSts.current = true;
			}else{
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad:false,
					formError:addInfo.error
				}));
				counterSts.current = false;
			}
		}
	},[apiRes.data.addUpdate]);

	// COUNTDOWN
	useEffect(() => {
		if(counterSts.current){
			const myInterval = setInterval(() => {
				const { seconds } = pageInfo.counter;
				if(seconds > 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						counter : { ...prevPageInfo.counter,
							seconds : seconds - 1
						}
					}));
				}
				if(seconds === 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						showForm:true
					}));
					clearInterval(myInterval);
					const storedData = localStorage.getItem('userData');
					if(storedData){
						let formData = JSON.parse(storedData);
						setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formData }));
					}
				}
			}, 1000);
			return () => clearInterval(myInterval);
		}
	}, [pageInfo.counter.seconds,pageInfo.showForm,pageInfo.counter]);

	//--------------------------------------------//
	//------------ USE EFFECT - END---------------//
	//--------------------------------------------//

	//------------------------------------------//
	//------ FUNCTION & ONCHANGE - START -------//
	//------------------------------------------// 

	//Input Change 
	const handleChange = (event,proFor) => {
		let formdata = pageInfo.formData;
		if(proFor === 'gender'){
			let value = event;
			formdata[String(proFor)] = value;
		}else if(proFor === 'mobile'){
			let value = event.target.value;
			if(/^\d{0,10}$/.test(value)) {
				formdata[String(proFor)] = value;
			}
		}else if(proFor === 'age'){
			let value = event.target.value;
			if(/^\d{0,2}$/.test(value)) {
				formdata[String(proFor)] = value;
			}
		}else{
			let value = event.target.value;
			formdata[String(proFor)] = value;
		}
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formdata,formError:{} }));
	};

	// SUBMIT FORM 
	const handleSubmit = (event) => {
		event.preventDefault();
		let frmData = { ...pageInfo.formData };
		if(frmData.gender){
			frmData['gender'] = frmData.gender.value;
		}
		frmData['pro_mode']  = 'ADD';
		frmData['form_mode'] = pageInfo.formId;
		dispatch(addUpdate({ sendTo:pgRef.current.api.cafsIndia,formData:frmData }));
		pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:true };
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formLoad:true }));
		localStorage.setItem('userData', JSON.stringify(pageInfo.formData));
	};

	//BACK TO FORM
	const onBack=()=>{
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
			showForm:true
		}));
		const storedData = localStorage.getItem('userData');
		if(storedData){
			let formData = JSON.parse(storedData);
			setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formData }));
		}
	};

	//------------------------------------------//
	//------ FUNCTION & ONCHANGE - END----------//
	//------------------------------------------//

	const demoOption = [
		{ label:'Please try later',value:0 }
	];

	return (
		<React.Fragment>
			{pageInfo.showForm ?
				<Grid container spacing={4} className="mb_25 common_form_bg" justifyContent={'center'} component="form" id="basic_form">
					<Grid size={{ md:6,sm:6,xs:12 }}>
						<TextField 
							required 
							onChange	 = {(e)=>handleChange(e,'name')} 
							disabled	 = {pageInfo.formLoad}
							helperText	 = {pageInfo.formError.name?pageInfo.formError.name:''}
							value		 = {pageInfo.formData.name?pageInfo.formData.name:''}
							error		 = {pageInfo.formError.name}
							label		 = "Your Name"
							autoComplete = 'off'
							sx			 = {{
								'& .MuiFormHelperText-root': {
									fontSize: '13px !important'
								}
							}}
							autoFocus
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						<TextField 
							required 
							onChange	 = {(e)=>handleChange(e,'mobile')} 
							disabled	 = {pageInfo.formLoad}
							helperText	 = {pageInfo.formError.mobile?pageInfo.formError.mobile:''}
							value		 = {pageInfo.formData.mobile?pageInfo.formData.mobile:''}
							error		 = {pageInfo.formError.mobile}
							label		 = "Contact"
							autoComplete = 'off'
							sx={{
								'& .MuiFormHelperText-root': {
									fontSize: '13px !important'
								}
							}}
							slotProps={{
								input: {
									endAdornment: <InputAdornment position="start">
										{pageInfo.formData.mobile?pageInfo.formData.mobile.length:0}/10
									</InputAdornment>
								}
							}}
						/>
					</Grid>	
					<Grid size={{ md:6,sm:6,xs:12 }}>
						<TextField 
							required
							onChange	 = {(e)=>handleChange(e,'age')} 
							disabled	 = {pageInfo.formLoad}
							helperText	 = {pageInfo.formError.age?pageInfo.formError.age:''}
							value		 = {pageInfo.formData.age?pageInfo.formData.age:''}
							error		 = {pageInfo.formError.age}
							label		 = "Your Age"
							autoComplete = 'off'
							sx={{
								'& .MuiFormHelperText-root': {
									fontSize: '13px !important'
								}
							}}
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }} className="mb_10">
						<Autocomplete
							options     = {pageInfo.dropData.gender?pageInfo.dropData.gender:demoOption}
							getOptionDisabled = {(option) =>
								option.isdisabled
							}
							name 		= "gender"
							disabled	= {pageInfo.formLoad}
							value		= {pageInfo.formData.gender?pageInfo.formData.gender:''}
							onChange	= {(e,newValue)=>handleChange(newValue,'gender')}
							renderInput = {(params) => <TextField {...params} label="Gender"/>}
						/>
					</Grid>
					<Grid size={12} sx={{ textAlign:'center' }}>
						<Button variant="contained" color="primary" type='submit' form={'basic_form'} className='btn_submit_form' loadingPosition='end' loading={pageInfo.formLoad} onClick={handleSubmit} endIcon={<CallMadeIcon className='font_weight_semiBold'/>}>Submit</Button>
					</Grid>
				</Grid>
				:
				<Grid container spacing={4} className="mb_25 common_form_bg" justifyContent={'center'}>
					<Grid size={12} textAlign="center">
						{imageExist({
							required : '/common',
							url      : '/splash.gif',
							alt      : 'splash',
							height   : '100px mb_25'
						})}
						<h3 className='mb_15 orange_cl'>Your request has been <span className='blue_cl'>submitted</span> successfully!!!</h3>
						<p className='mb_10'>Your information has been successfully received. We will review your submission and get back to you as soon as possible.</p>
						<p className='mb_15 gray_cl font_14'>Back to form in <span className='mb_15 orange_cl'>{pageInfo.counter.seconds} seconds</span></p>
						<Button variant="contained" color="primary" className='btn_submit_form' loadingPosition='end' onClick={onBack}>Back</Button>
					</Grid>
				</Grid>
			}
		</React.Fragment>
	);
};
//---------------------------------------------------------------------------------------------//

// CAREERS MODAL FORM 
export const CareersForm = (props) => {

	//-----------------------------------------//
	//------------ USE REF - START ------------//
	//-----------------------------------------//

	const pgRef = useRef({
		api : {
			cafsIndia : '/cafs_india'
		},
		apiCall : {
			addUpd : false
		}
	});
	const counterSts = useRef(false);

	//---------------------------------------//
	//------------ USE REF - END ------------//
	//---------------------------------------//

	//-------------------------------------------//
	//------------ USE STATE - START ------------//
	//-------------------------------------------//

	const [fileName, setFileName] = useState('');
	const [pageInfo,setPageInfo]  = useState({
		dropData    : {},
		uploadedFile : '',
		formData     : {
			email  : '',
			mobile : '',
			name   : '',
			resume : ''
		},
		desinationId : props.jobId,
		showModal    : props.showModal,
		formLoad     : false, 
		formError    : {},
		showForm     : true,
		showError    : false,
		counter      : { seconds:10 }
	});

	//-----------------------------------------//
	//------------ USE STATE - END ------------//
	//-----------------------------------------//
    
	//--------------------------------------------//
	//------------ USE EFFECT - START ------------//
	//--------------------------------------------//

	useEffect(()=>{
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,showModal:props.showModal,desinationId:props.jobId }));
	},[props.showModal,props.jobId]);

	//REDUX-RESPONSE
	const dispatch = useDispatch();
	const apiRes   = useSelector((state) => {
		return { 
			data : {
				careerAddUpdate : state.reducer.careerAddUpdate
			}
		};
	});

	//DROPDOWN
	useEffect(()=>{
		if(pgRef.current.apiCall.dropSts){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,dropSts:false };
			let dropInfo          = apiRes.data.commonDropDown;
			if(dropInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,dropData:dropInfo.rslt }));
			}
		}
	},[apiRes.data.commonDropDown]);

	//ADDUPDATE
	useEffect(()=>{
		if(pgRef.current.apiCall.addUpd){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:false };
			let addInfo          = apiRes.data.careerAddUpdate;
			if(addInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad     : false,
					// showModal : false,
					formData     : {},
					uploadedFile : false,
					showForm     : false,
					showError    : false,
					counter      : { seconds:10 }
				}));
				counterSts.current = true;
			}else{
				let formError      = false;
				let showForm       = true;
				let formdata       = pageInfo.formData;
				let uploadedFile   = pageInfo.uploadedFile;
				counterSts.current = false;
				if(Array.isArray(addInfo.error)){
					counterSts.current = true;
					formError    = true;
					showForm     = false;
					formdata     = {};
					uploadedFile = false;
				}
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad     : false,
					showForm     : showForm,
					showError    : formError,
					formError    : addInfo.error,
					formData     : formdata,
					uploadedFile : uploadedFile,
					counter      : { seconds:10 }
				}));
			}
		}
	},[apiRes.data.careerAddUpdate,pageInfo.formData,pageInfo.uploadedFile]);

	// COUNTDOWN
	useEffect(() => {
		if(counterSts.current){
			const myInterval = setInterval(() => {
				const { seconds } = pageInfo.counter;
				if(seconds > 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						counter : { ...prevPageInfo.counter,
							seconds : seconds - 1
						}
					}));
				}
				if(seconds === 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						showForm:true
					}));
					clearInterval(myInterval);
				}
			}, 1000);
			return () => clearInterval(myInterval);
		}
	}, [pageInfo.counter.seconds,pageInfo.showForm,pageInfo.showError,pageInfo.counter]);

	//--------------------------------------------//
	//------------ USE EFFECT - END---------------//
	//--------------------------------------------//

	//------------------------------------------//
	//------ FUNCTION & ONCHANGE - START -------//
	//------------------------------------------// 
 
	//HANDLE CLOSE DIALOG
	const handleClose = () => {
		if (props.onCloseDialog) {
			props.onCloseDialog(false); 
		}
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formError:{},formData:{},uploadedFile:false }));
	};

	//FILE UPLOAD CHANGE
	const handleFileChange = (event) => {
		const files = event.target.files;
		if (files && files.length > 0) {
			setFileName(files[0].name); // Store the name of the first file
		}
	};

	//INPUT CHANGE
	const handleChange = (event,proFrom) => {
		let formdata = pageInfo.formData;
		if(proFrom === 'resume'){
			const files  = event.target.files;
			if (files && files.length > 0) {
				formdata[String(proFrom)] = files[0];
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,uploadedFile:files[0].name }));
			}
		}else if(proFrom === 'mobile'){
			let value = event.target.value;
			if(/^\d{0,10}$/.test(value)) {
				formdata[String(proFrom)] = value;
			}
		}else{
			let value = event.target.value;
			formdata[String(proFrom)] = value;
		}
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
			formData :formdata,
			formError:{}
		}));
	};

	//HANDLE SUBMIT FORM
	const handleSubmit = async(event) => {
		event.preventDefault();
		let formdata   = pageInfo.formData;
		let uploadFile = formdata.resume;
		let frmData    = { ...pageInfo.formData };
		if(uploadFile){
			const fileContent  = await readFile(uploadFile);
			frmData['resume']  = fileContent;
		}
		frmData['pro_mode']    = 'ADD';
		frmData['designation'] = pageInfo.desinationId;
		frmData['form_mode']   = '6814ac4c5daa8c390835806f';
		dispatch(careerAddUpdate({ sendTo:pgRef.current.api.cafsIndia,formData:frmData }));
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formLoad:true }));
		pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:true };
	};

	//BACK FROM SUCCESS OR ERROR MSG
	const onBack=()=>{
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
			showForm:true
		}));
	};

	//------------------------------------------//
	//------ FUNCTION & ONCHANGE - END----------//
	//------------------------------------------//

	return (
		<Dialog
			open={pageInfo.showModal}
			fullWidth
			maxWidth="sm"
			onClose={handleClose}
			PaperProps={{ sx: { borderRadius: '20px' } }}
		>
			<Grid container rowSpacing={0} className="careers_form_dialog">
				<Grid className="career_form_cancel_btn">
					<IconButton onClick={handleClose}><CloseIcon sx={{ fontSize:'25px !important',color:'#cfcfcf' }}/></IconButton>
				</Grid>
				<Grid size={12}>
					<p className='blue_cl weight_bold custom_h1 font_weight_medium'>My Information</p>
					<p className='blue_cl weight_bold custom_h1 font_weight_medium'>Fill out the information <span className='orange_cl custom_h1 font_weight_medium'>below !</span></p>
				</Grid>
				<Grid size={12} mt="10px">
					{pageInfo.showForm ?
						<Grid container rowSpacing={3} columnSpacing={2} mb={'5px'} component="form" id="career_form">
							<Grid size={{ md:6,xs:12 }}>
								<TextField
									required
									label		 = "Your Name" 
									onChange	 = {(e)=>handleChange(e,'name')} 
									disabled	 = {pageInfo.formLoad}
									helperText	 = {pageInfo.formError.name?pageInfo.formError.name:''}
									value		 = {pageInfo.formData.name?pageInfo.formData.name:''}
									error		 = {pageInfo.formError.name}
									autoComplete = 'off'
									sx={{
										'& .MuiFormHelperText-root': {
											fontSize: '13px !important'
										}
									}}
								/>
							</Grid>
							<Grid size={{ md:6,xs:12 }}>
								<TextField
									required
									label		 = "Your Email"
									onChange	 = {(e)=>handleChange(e,'email')} 
									disabled	 = {pageInfo.formLoad}
									helperText	 = {pageInfo.formError.email?pageInfo.formError.email:''}
									value		 = {pageInfo.formData.email?pageInfo.formData.email:''}
									error		 = {pageInfo.formError.email}
									autoComplete = 'off'
									sx			 = {{
										'& .MuiFormHelperText-root': {
											fontSize: '13px !important'
										}
									}}
								/>
							</Grid>
							<Grid size={{ md:6,xs:12 }}>
								<TextField 
									label="Contact" required
									onChange	 = {(e)=>handleChange(e,'mobile')}
									disabled	 = {pageInfo.formLoad}
									helperText	 = {pageInfo.formError.mobile?pageInfo.formError.mobile:''}
									value		 = {pageInfo.formData.mobile?pageInfo.formData.mobile:''}
									error		 = {pageInfo.formError.mobile}
									autoComplete = 'off'
									sx			 = {{
										'& .MuiFormHelperText-root': {
											fontSize: '13px !important'
										}
									}}
									slotProps={{
										input: {
											endAdornment: <InputAdornment position="start">
												{pageInfo.formData.mobile?pageInfo.formData.mobile.length:0}/10
											</InputAdornment>
										}
									}}
								/>
							</Grid>
							<Grid size={12}>
								<Stack direction="column" spacing={0.2}>
									<Grid>
										<Button
											component = "label"
											role      = {undefined}
											variant   = "text"
											color     = {fileName?'primary':'secondary'}
											tabIndex  = {-1}
											sx        = {{ borderRadius:'20px' }}
											startIcon = {<AttachFileIcon />}
											onChange  = {(e)=>handleChange(e,'resume')} 
											disabled  = {pageInfo.formLoad}
										>
											Attach your CV
											<VisuallyHiddenInput
												onChange = {handleFileChange}
												type     = "file"
												accept   = '.pdf,.docx,.doc'
											/>
										</Button>	
										<span className='custom_h5'>(Only PDF and Word documents under 2MB are accepted)</span>
									</Grid>
									{pageInfo.formError.resume ?
										<p style={{ color:'red' }}>{pageInfo.formError.resume}</p>
										: 
										<p style={{ marginLeft:'10px' }}>{pageInfo.uploadedFile && <div>Selected file: {pageInfo.uploadedFile}</div>}</p>
									}
								</Stack>
							</Grid>
							<Grid size={12}>
								<Button variant='contained' type='submit' form={'career_form'} startIcon={<CallMadeIcon/>} loadingPosition="start" loading={pageInfo.formLoad} className='btn_blue_white' color='secondary' onClick={handleSubmit}>Submit</Button>
							</Grid>
						</Grid>
						:
						<React.Fragment>
							{pageInfo.showError ?
								<Grid container spacing={2}>
									<Grid size={12} textAlign="center">
										{imageExist({
											required  : '/common',
											url       : '/error.gif',
											alt       : 'splash',
											height    : '100px mb_25'
										})}
										<h3 className='mb_15 orange_cl'>You have already <span className='blue_cl'>applied</span> for this position</h3>
										<p className='mb_10'>We will review your submission and get back to you as soon as possible.Alternatively, you can apply for this position again after two months.</p>
										<p className='mb_15 gray_cl font_14'>Back to form in <span className='mb_15 orange_cl'>{pageInfo.counter.seconds} seconds</span></p>
										<Button variant="contained" color="primary" className='btn_submit_form' loadingPosition='end' onClick={onBack}>Back</Button>
									</Grid>
								</Grid>
								:
								<Grid container spacing={2}>
									<Grid size={12} textAlign="center">
										{imageExist({
											required  : '/common',
											url       : '/splash.gif',
											alt       : 'splash',
											height    : '100px mb_25'
										})}
										<h3 className='mb_15 orange_cl'>Your request has been <span className='blue_cl'>submitted</span> successfully!!!</h3>
										<p className='mb_10'>Your information has been successfully received. We will review your submission and get back to you as soon as possible.</p>
										<p className='mb_15 gray_cl font_14'>Back to form in <span className='mb_15 orange_cl'>{pageInfo.counter.seconds} seconds</span></p>
										<Button variant="contained" color="primary" className='btn_submit_form' onClick={onBack}>Back</Button>
									</Grid>
								</Grid>
							}
						</React.Fragment>
					}
				</Grid>
			</Grid>
		</Dialog>
	);
};


//CAREERS BANNER FORM
export const CareersBannerForm = () => {

	//-----------------------------------------//
	//------------ USE REF - START ------------//
	//-----------------------------------------//

	const pgRef = useRef({
		api : {
			cafsIndia  : '/cafs_india'
		},
		apiCall : {
			initCall : true,
			dropSts  : false,
			addUpd   : false
		}
	});
	const counterSts = useRef(false);

	//---------------------------------------//
	//------------ USE REF - END ------------//
	//---------------------------------------//

	//-------------------------------------------//
	//------------ USE STATE - START ------------//
	//-------------------------------------------//

	const [pageInfo,setPageInfo] = useState({
		dropData    : {},
		uploadedFile : '',
		formData     : {
			designation : '',
			email       : '',
			name        : '',
			mobile      : ''
		},
		formLoad     : false,
		formError    : {},
		showForm     : true,
		showError    : false,
		counter      : { seconds:10 }
	});

	const demoDrop = [
		{ label: 'Please try later', value:0 }
	];

	//-----------------------------------------//
	//------------ USE STATE - END ------------//
	//-----------------------------------------//

	//---------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - START ------------//
	//---------------------------------------------------------------//

	const dispatch = useDispatch();
	const apiRes   = useSelector((state) => {
		return { 
			data : {
				commonDropDown : state.reducer.commonDropDown,
				careerAddUpdate : state.reducer.careerAddUpdate
			}
		};
	});

	//-------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - END ------------//
	//-------------------------------------------------------------//

	//--------------------------------------------//
	//------------ USE EFFECT - START ------------//
	//--------------------------------------------//

	// INIT CALL
	useEffect(()=>{ 
		(async()=>{
			if(pgRef.current.apiCall.initCall){
				dispatch(addUpdate({ sendTo:pgRef.current.api.cafsIndia }));
				dispatch(getCommonDrop({ sendTo:pgRef.current.api.cafsIndia }));
				pgRef.current.apiCall = await { ...pgRef.current.apiCall,initCall:false,dropSts:true };
			}
		})();
	},[dispatch]);

	//DROPDOWN
	useEffect(()=>{
		if(pgRef.current.apiCall.dropSts){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,dropSts:false };
			let dropInfo         = apiRes.data.commonDropDown;
			if(dropInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,dropData:dropInfo.rslt }));
			}
		}
	},[apiRes.data.commonDropDown]);

	//ADD UPDATE
	useEffect(()=>{
		if(pgRef.current.apiCall.addUpd){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:false };
			let addInfo          = apiRes.data.careerAddUpdate;
			if(addInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad     : false,
					formData     : {},
					uploadedFile : '',
					showForm     : false,
					showError    : false,
					counter      : { seconds:10 }
				}));
				counterSts.current = true;
			}else{
				let formError      = false;
				let showForm       = true;
				let formdata       = pageInfo.formData;
				let uploadedFile   = pageInfo.uploadedFile;
				counterSts.current = false;
				if(Array.isArray(addInfo.error)){
					counterSts.current = true;
					formError   = true;
					showForm    = false;
					formdata    = {};
					uploadedFile = false;
				}
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad     : false,
					showForm     : showForm,
					showError    : formError,
					formError    : addInfo.error,
					formData     : formdata,
					uploadedFile : uploadedFile,
					counter      : { seconds:10 }
				}));
			}
		}
	},[apiRes.data.careerAddUpdate,pageInfo.formData,pageInfo.uploadedFile]);

	// COUNTDOWN
	useEffect(() => {
		if(counterSts.current){
			const myInterval = setInterval(() => {
				const { seconds } = pageInfo.counter;
				if(seconds > 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						counter : { ...prevPageInfo.counter,
							seconds : seconds - 1
						}
					}));
				}
				if(seconds === 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						showForm:true
					}));
					clearInterval(myInterval);
				}
			}, 1000);
			return () => clearInterval(myInterval);
		}
	}, [pageInfo.counter.seconds,pageInfo.showForm,pageInfo.showError,pageInfo.counter]);

	//--------------------------------------------//
	//------------ USE EFFECT - END---------------//
	//--------------------------------------------//


	//--------FUNCTIONS-START----------//
    
	//HANDLE INPUT CHANGES
	const handleChange = (event,proFrom) => {
		let formdata = pageInfo.formData;
		if(proFrom === 'resume'){
			const files  = event.target.files;
			if (files && files.length > 0) {
				formdata[String(proFrom)] = files[0];
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,uploadedFile:files[0].name }));
			}
		}else if(proFrom === 'designation'){
			let value = event;
			formdata[String(proFrom)] = value;
		}else if(proFrom === 'mobile'){
			let value = event.target.value;
			if(/^\d{0,10}$/.test(value)) {
				formdata[String(proFrom)] = value;
			}
		}else{
			let value = event.target.value;
			formdata[String(proFrom)] = value;
		}
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
			formData  : formdata,
			formError : {}
		}));
	};

	//SUBMIT FORM
	const handleSubmit = async() => {
		let formdata   = pageInfo.formData;
		let uploadFile = formdata.resume;
		let frmData    = { ...formdata };
		if(frmData.designation){
			frmData['designation'] = frmData.designation.value;
		}
		if(uploadFile){
			const fileContent  = await readFile(uploadFile);
			frmData['resume'] = fileContent;
		}
		frmData['pro_mode']   = 'ADD';
		frmData['form_mode']  = '6814ac4c5daa8c390835806f';
		dispatch(careerAddUpdate({ sendTo:pgRef.current.api.cafsIndia,formData:frmData }));
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formLoad:true }));
		pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:true };
	};

	//BACK FROM SUCCESS OR ERROR MSG
	const onBack=()=>{
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
			showForm:true
		}));
	};

	//--------FUNCTIONS-END------------//

	return(
		<React.Fragment>
			{pageInfo.showForm ?
				<Grid container columnSpacing={5} rowSpacing={3}>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						<TextField
							required
							label="Your Name"
							onChange	 = {(e)=>handleChange(e,'name')}
							name 		 = "name"
							disabled	 = {pageInfo.formLoad}
							helperText	 = {pageInfo.formError.name?pageInfo.formError.name:''}
							error		 = {pageInfo.formError.name}
							value		 = {pageInfo.formData.name?pageInfo.formData.name:''}
							autoComplete = 'off'
							sx		     = {{ '& .MuiInputLabel-root': { color: 'white' } }}
							InputProps   = {{
								sx: {
									color:'#ffffff',
									'&::placeholder': {
										color: '#ffffff'
									},
									'&:before': {
										borderBottomColor:'#808b98'
									},
									'&:hover:not(.Mui-disabled):before':{
										borderBottomColor: '#808b98',
										borderBottom : '1px solid'
									},
									'&:after': {
										borderBottomColor: '#808b98',
										borderBottom : '2px solid'
									}
								}
							}}
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						<TextField
							required
							label 		 = "Your Email" 
							onChange	 = {(e)=>handleChange(e,'email')}
							name 		 = "email"
							disabled	 = {pageInfo.formLoad}
							helperText	 = {pageInfo.formError.email?pageInfo.formError.email:''}
							error		 = {pageInfo.formError.email}
							value		 = {pageInfo.formData.email?pageInfo.formData.email:''}
							autoComplete = 'off'
							sx			 = {{ '& .MuiInputLabel-root': { color: 'white' } }}
							InputProps	 = {{
								sx: {
									color:'#ffffff',
									'&::placeholder': {
										color: '#ffffff'
									},
									'&:before': {
										borderBottomColor:'#808b98'
									},
									'&:hover:not(.Mui-disabled):before':{
										borderBottomColor: '#808b98',
										borderBottom : '1px solid'
									},
									'&:after': {
										borderBottomColor: '#808b98',
										borderBottom : '2px solid'
									}
								}
							}}
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						<TextField
							required
							label		 = "Contact"
							autoComplete = 'off'
							onChange     = {(e)=>handleChange(e,'mobile')}
							disabled     = {pageInfo.formLoad}
							helperText   = {pageInfo.formError.mobile?pageInfo.formError.mobile:''}
							error	     = {pageInfo.formError.mobile}
							value	     = {pageInfo.formData.mobile?pageInfo.formData.mobile:''}
							sx		     = {{ '& .MuiInputLabel-root': { color: 'white' } }}
							className    = 'careers_form_input'
							// InputProps   = {{
							// 	sx: {
							// 		color:'#ffffff',
							// 		'&::placeholder': {
							// 			color: '#ffffff'
							// 		},
							// 		'&:before': {
							// 			borderBottomColor:'#808b98'
							// 		},
							// 		'&:hover:not(.Mui-disabled):before':{
							// 			borderBottomColor: '#808b98',
							// 			borderBottom : '2px solid'
							// 		},
							// 		'&:after': {
							// 			borderBottomColor: '#808b98',
							// 			borderBottom : '3px solid'
							// 		}
							// 	}
							// }}
							slotProps = {{
								input: {
									endAdornment: <InputAdornment position="start">
										{pageInfo.formData.mobile?pageInfo.formData.mobile.length:0}/10
									</InputAdornment>,
									sx: {
										color: '#ffffff',
										'&::placeholder': {
											color: '#ffffff'
										},
										'&:before': {
											borderBottomColor: '#808b98'
										},
										'&:hover:not(.Mui-disabled):before': {
											borderBottomColor: '#808b98',
											borderBottom: '1px solid'
										},
										'&:after': {
											borderBottomColor: '#808b98',
											borderBottom: '2px solid'
										}
									}
								}
							}}
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						<Autocomplete
							disablePortal
							options     = {pageInfo.dropData.designation?pageInfo.dropData.designation:demoDrop}
							getOptionDisabled = {(option) =>
								option.isdisabled
							}
							name		= "designation"
							className	= "careers_banner_form"
							disabled	= {pageInfo.formLoad}
							helperText	= {pageInfo.formError.designation?pageInfo.formError.designation:''}
							error		= {pageInfo.formError.designation}
							value		= {pageInfo.formData.designation?pageInfo.formData.designation:''}
							onChange	= {(e,newValue)=>handleChange(newValue,'designation')}
							renderInput = {(params) => <TextField {...params} label="Designation"/>}
							sx			= {{
								'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
									borderBottomColor: 'white !important'
								}
							}}
						/>
					</Grid>
					<Grid size={12} className="mb_15">
						<Stack direction="column" spacing={2}>
							<div>
								<Button
									component = "label"
									role      = {undefined}
									variant   = "text"
									name      = 'uploadFile'
									tabIndex  = {-1}
									sx        = {{ borderRadius:'20px',color:'white' }}
									startIcon = {<AttachFileIcon />}
									onChange  = {(e)=>handleChange(e,'resume')}
								>
									Attach your CV
									<VisuallyHiddenInput
										type   = "file"
										accept = '.pdf,.docx,.doc'
									/>
								</Button>
								<span className='custom_h5 white_cl'>(Only PDF and Word documents under 2MB are accepted)</span>
							</div>
							{pageInfo.formError.resume ?
								<p style={{ color:'red' }}>{pageInfo.formError.resume}</p>
								: 
								<p style={{ color:'white' }}>{pageInfo.uploadedFile && <div>Selected file : {pageInfo.uploadedFile}</div>}</p>
							}
						</Stack>
					</Grid>
					<Button variant='contained' startIcon={<CallMadeIcon/>} onClick={handleSubmit}  className='about_submit_btn'>Submit</Button>
				</Grid>
				:
				<React.Fragment>
					{pageInfo.showError ?
						<Grid container spacing={2} className="mb_25 common_form_bg">
							<Grid size={12} textAlign="center">
								{imageExist({
									required  : '/common',
									url       : '/error.gif',
									alt       : 'splash',
									height    : '100px mb_25'
								})}
								<h3 className='mb_15 orange_cl'>You have already <span className='blue_cl'>applied</span> for this position</h3>
								<p className='mb_10 blue_cl'>We will review your
									submission and get back to you as soon as possible.
									Alternatively, you can apply for this position again after two months.
								</p>
								<p className='mb_15 gray_cl font_14'>Back to form in <span className='mb_15 orange_cl'>{pageInfo.counter.seconds} seconds</span></p>
								<Button variant="contained" color="primary" className='btn_submit_form' loadingPosition='end' onClick={onBack}>Back</Button>
							</Grid>
						</Grid>
						:
						<Grid container spacing={4} className="mb_25 common_form_bg" justifyContent={'center'}>
							<Grid size={12} textAlign="center">
								{imageExist({
									required  : '/common',
									url       : '/splash.gif',
									alt       : 'splash',
									height    : '100px mb_25'
								})}
								<h3 className='mb_15 orange_cl'>Your request has been <span className='blue_cl'>submitted</span> successfully!!!</h3>
								<p className='mb_10 blue_cl'> information has been successfully received. We will review your submission and get back to you as soon as possible.</p>
								<p className='mb_15 gray_cl font_14'>Back to form in <span className='mb_15 orange_cl'>{pageInfo.counter.seconds} seconds</span></p>
								<Button variant="contained" color="primary" className='btn_submit_form' loadingPosition='end' onClick={onBack}>Back</Button>
							</Grid>
						</Grid>
					}
				</React.Fragment>
			}
		</React.Fragment>
	);
};


////////////////////    contact - us form   ////////////////////

export const ContactForm = (props) => {
    
	//-----------------------------------------//
	//------------ USE REF - START ------------//
	//-----------------------------------------//
    
	const pgRef = useRef({
		api : {
			cafsIndia  : '/cafs_india'
		},
		apiCall : {
			initCall : true,
			dropSts  : false
		}
	});
	const counterSts = useRef(false);
    
	//---------------------------------------//
	//------------ USE REF - END ------------//
	//---------------------------------------//
    
	//-------------------------------------------//
	//------------ USE STATE - START ------------//
	//-------------------------------------------//
    
	const [pageInfo,setPageInfo] = useState({
		dropData      : {},
		formError     : {},
		formData      : {
			name    : '',
			mobile  : '',
			service : ''
		},
		formLoad      : false,
		formId        : props.proFrom,
		proFor        : props.proFor,
		SuccessMsg    : false,
		showForm      : true,
		counter       : { seconds:10 }
	}); 

	//-----------------------------------------//
	//------------ USE STATE - END ------------//
	//-----------------------------------------//
    
	//---------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - START ------------//
	//---------------------------------------------------------------//

	const dispatch = useDispatch();
	const apiRes   = useSelector((state) => {
		return { 
			data : {
				commonDropDown : state.reducer.commonDropDown,
				addUpdate       : state.reducer.addUpdate
			}
		};
	});
    
	//-------------------------------------------------------------//
	//------------ USE DISPATCH & REDUX RESPONSE - END ------------//
	//-------------------------------------------------------------//

	//--------------------------------------------//
	//------------ USE EFFECT - START ------------//
	//--------------------------------------------//
    
	// INIT CALL
	useEffect(()=>{ 
		(async()=>{
			if(pgRef.current.apiCall.initCall){
				dispatch(getCommonDrop({ sendTo:pgRef.current.api.cafsIndia }));
				pgRef.current.apiCall = await { ...pgRef.current.apiCall,initCall:false,dropSts:true };
			}
		})();
	},[dispatch]);

	//DROPDOWN
	useEffect(()=>{
		if(pgRef.current.apiCall.dropSts){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,dropSts:false };
			let dropInfo         = apiRes.data.commonDropDown;
			if(dropInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,dropData:dropInfo.rslt }));
			}
		}
	},[apiRes.data.commonDropDown]);

	//ADD UPDATE
	useEffect(()=>{
		if(pgRef.current.apiCall.addUpd){
			pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:false };
			let addInfo          = apiRes.data.addUpdate;
			if(addInfo.sts){
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad   : false,
					formData   : {},
					formError  : {},
					SuccessMsg : true,
					showForm   : false,
					counter    : { seconds:10 }
				}));
				counterSts.current = true;
			}else{
				setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
					formLoad:false,
					formError:addInfo.error,
					SuccessMsg : false
				}));
				counterSts.current = false;
			}
		}
	},[apiRes.data.addUpdate]);

	// COUNTDOWN
	useEffect(() => {
		if(counterSts.current){
			const myInterval = setInterval(() => {
				const { seconds } = pageInfo.counter;
				if(seconds > 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						counter : { ...prevPageInfo.counter,
							seconds : seconds - 1
						}
					}));
				}
				if(seconds === 0){
					setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
						showForm:true
					}));
					clearInterval(myInterval);
				}
			}, 1000);
			return () => clearInterval(myInterval);
		}
	}, [pageInfo.counter.seconds,pageInfo.showForm,pageInfo.counter]);

	//--------------------------------------------//
	//------------ USE EFFECT - END---------------//
	//--------------------------------------------//

	//HANDLE INPUT CHANGE
	const handleChange = (event,proFrom) => {
		let formdata = pageInfo.formData;
		if(proFrom === 'service'){
			let value = event;
			formdata[String(proFrom)] = value;
		}else if(proFrom === 'mobile'){
			let value = event.target.value;
			if(/^\d{0,10}$/.test(value)) {
				formdata[String(proFrom)] = value;
			}
		}else{
			let value                 = event.target.value;
			formdata[String(proFrom)] = value;
		}
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formData:formdata,formError:{} }));
	};

	//HANDLE FORM SUBMIT
	const handleSubmit = () => {
		let frmData = { ...pageInfo.formData };
		if(frmData.service){
			frmData['service'] = frmData.service.value;
		}
		frmData['pro_mode']  = 'ADD';
		frmData['form_mode'] = pageInfo.formId;
		dispatch(addUpdate({ sendTo:pgRef.current.api.cafsIndia,formData:frmData }));
		pgRef.current.apiCall = { ...pgRef.current.apiCall,addUpd:true };
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,formLoad:true }));
	};

	//BACK FROM SUCCESS OR ERROR MSG
	const onBack=()=>{
		setPageInfo((prevPageInfo)=>({ ...prevPageInfo,
			showForm:true
		}));
	};

	const demoOption = [
		{ label:'Please try later',value:0 }
	];

	let proFrom = pageInfo.proFor === 'about_us';

	return(
		<React.Fragment>
			{pageInfo.showForm ?
				<Grid container rowSpacing={6} columnSpacing={2}>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						{proFrom?
							<p>Name*</p>
							:''
						}
						<TextField 
							required 
							label		 = {proFrom?'':'Name'}
							name 		 = "name"
							onChange	 = {(e)=>handleChange(e,'name')} 
							disabled     = {pageInfo.formLoad}
							helperText   = {pageInfo.formError.name?pageInfo.formError.name:''}
							value	     = {pageInfo.formData.name?pageInfo.formData.name:''}
							error	     = {pageInfo.formError.name}
							placeholder  = "Your Name"
							autoComplete = 'off'
							variant		 = 'outlined'
							size		 = "small"
							className	 = 'white_bg_input'
							sx={{
								'& .MuiFormHelperText-root': {
									fontSize: '13px !important'
								}
                            
							}}
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						{proFrom?
							<p>Contact*</p>
							:''
						}
						<TextField 
							required 
							label		 = {proFrom?'':'Contact'}
							name		 = "contact"
							onChange	 = {(e)=>handleChange(e,'mobile')} 
							disabled	 = {pageInfo.formLoad}
							helperText	 = {pageInfo.formError.mobile?pageInfo.formError.mobile:''}
							value		 = {pageInfo.formData.mobile?pageInfo.formData.mobile:''}
							error		 = {pageInfo.formError.mobile}
							placeholder  = "Mobile Number"
							autoComplete = 'off'
							className	 = 'white_bg_input'
							variant		 = 'outlined'
							size		 = "small"
							sx			 = {{
								'& .MuiFormHelperText-root': {
									fontSize: '13px !important'
								}
							}}
							slotProps={{
								input: {
									endAdornment: <InputAdornment position="start">
										{pageInfo.formData.mobile?pageInfo.formData.mobile.length:0}/10
									</InputAdornment>
								}
							}}
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						{proFrom?
							<p>Email</p>
							:''
						}
						<TextField
							className	 = 'white_bg_input'
							variant		 = 'outlined'
							size		 = "small"
							label		 = {proFrom?'':'Email'}
							name		 = "email"
							onChange	 = {(e)=>handleChange(e,'email')} 
							disabled	 = {pageInfo.formLoad}
							helperText	 = {pageInfo.formError.email?pageInfo.formError.email:''}
							value		 = {pageInfo.formData.email?pageInfo.formData.email:''}
							error		 = {pageInfo.formError.email}
							placeholder  = "example@gmail.com"
							autoComplete = 'off'
						/>
					</Grid>
					<Grid size={{ md:6,sm:6,xs:12 }}>
						{proFrom?
							<p>Service</p>
							:''
						}
						<Autocomplete
							options           = {pageInfo.dropData.cafsindia_service?pageInfo.dropData.cafsindia_service:demoOption}
							getOptionDisabled = {(option) =>
								option.isdisabled
							}
							name = "Service"
							// variant='outlined'
							size="small"
							className = {pageInfo.formId === '10' ?'careers_banner_form':''}
							disabled  = {pageInfo.formLoad}
							value	  = {pageInfo.formData.service?pageInfo.formData.service:''}
							onChange  = {(e,newValue)=>handleChange(newValue,'service')}
							slotProps = {{
								textField: {
									error:pageInfo.formError.service,
									helperText:pageInfo.formError.service?pageInfo.formError.service:'',
									required:true
								}
							}}
							sx={pageInfo.formId === '10'?{
								'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
									borderBottomColor: 'white !important'
								}
							}:{}}
							renderInput = {(params) => <TextField 
								required
								className   = 'white_bg_input' 
								size	    = "small" 
								variant	    = 'outlined' 
								label	    = {proFrom?'':'Service'}
								placeholder = 'select Service'
								{...params}  
								helperText  = {pageInfo.formError.service?pageInfo.formError.service:''} 
								error		= {pageInfo.formError.service}
								sx			= {{
									'& .MuiFormHelperText-root': {
										fontSize: '13px !important'
									}
								}}
							/>}
						/>
					</Grid>
					<Grid size={{ md:8,sm:8,xs:12 }}>
						{proFrom?
							<p>How Can We Help You?</p>
							:''
						}
						<TextField 
							placeholder = "share few message" 
							label		= {proFrom?'':'Message'}
							name 		= "message"
							multiline
							rows		= {2}
							className	= 'white_bg_input'
							variant		= 'outlined'
							size		= "small"
							onChange	= {(e)=>handleChange(e,'description')} 
							value		= {pageInfo.formData.description?pageInfo.formData.description:''}
						/>
					</Grid>
					<Grid size={{ md:4,sm:3,xs:12 }} sx={{ textAlign:'right',justifyItems:'flex-end',alignSelf:'flex-end' }}>
						<Button variant='contained' className={proFrom?'about_submit_btn':'btn_submit_form'} onClick={handleSubmit} loading={pageInfo.formLoad}>Submit</Button>
					</Grid>
				</Grid>
				:
				<Grid container spacing={4} className="mb_25 common_form_bg" justifyContent={'center'}>
					<Grid size={12} textAlign="center">
						{imageExist({
							required  : '/common',
							url       : '/splash.gif',
							alt       : 'splash',
							height    : '100px mb_25'
						})}
						<h3 className='mb_15 orange_cl'>Your request has been <span className='blue_cl'>submitted</span> successfully!!!</h3>
						<p className='mb_10 blue_cl'>Your information has been successfully received. We will review your submission and get back to you as soon as possible.</p>
						<p className='mb_15 gray_cl font_14'>Back to form in <span className='mb_15 orange_cl'>{pageInfo.counter.seconds} seconds</span></p>
						<Button variant="contained" color="primary" className='btn_submit_form' loadingPosition='end' onClick={onBack}>Back</Button>
					</Grid>
				</Grid>
			}
		</React.Fragment>
	);
};

//HEADER
export const PageHeaders = (pageHeader) => {
	// only for keywords since keywords value in array - by KAV
	let keywords = '';
	if(pageHeader.metaKeywords){
		if(pageHeader.metaKeywords.length>0){
			keywords = pageHeader.metaKeywords;
		}
	}
	return(
		<Helmet> 
			{pageHeader.canonical?<link rel="canonical" href={pageHeader.canonical}/>:null}
			{pageHeader.robots?<meta name='robots' content={pageHeader.robots}/>:<meta name="robots" content="noindex,nofollow"/>}
			{pageHeader.metaTitle?<title>{pageHeader.metaTitle}</title>:<title>CAFS India - Get Financial Consultation at your Doorstep</title>}
			{pageHeader.metaDesc?<meta name='Description' content={pageHeader.metaDesc} />:<meta name="Description" content="CAFS offers Financial consultation for Health insurance, Life insurance, Mutual fund &amp; Stocks. With CAFS choose the best investment."/>}
			{keywords?<meta name='Keywords' content={keywords} />:<meta name="Keywords" content="mutual funds, mf investment, best investment funds, mutual fund investment companies, best mutual fund investments, Mutual Fund Investment Plans via SIP, best mutual fund to invest, best mutual funds for SIP, Top investment schemes, Top investment schemes in India, mutual fund calculator,cafsmoney."/>}
			{pageHeader['og:image']?<meta property="og:image" content={pageHeader['og:image']} />:null}
			{pageHeader['og:title']?<meta property="og:title" content={pageHeader['og:title']} />:null}
			{pageHeader['og:description']?<meta property="og:description" content={pageHeader['og:description']} />:null}
			{pageHeader['og:url']?<meta property="og:url" content={pageHeader['og:url']} />:null}
			{pageHeader['og:type']?<meta property="og:type" content={pageHeader['og:type']} />:null}
			{pageHeader.json?<script type="application/ld+json">{JSON.stringify(pageHeader.json)}</script>:null} 
			{pageHeader.faqJson?<script type="application/ld+json">{JSON.stringify(pageHeader.faqJson)}</script>:null} 
		</Helmet>
	);
};

//CUSTOM BREADCRUMB
export const CustomBreadcrumbs = (breadInfo) => {
	let breads = [];
	if(breadInfo){
		let proInfo = breadInfo.info;
		if(proInfo){
			if(proInfo.length>0){
				proInfo.map((list,index)=>{
					breads.push(<Link key={index} className={list.active?'breadCrumb_link_ac':'breadCrumb_link'} to={list.url}>{list.urlName}</Link>);
					return true;
				});
			}
		}
	}
	return (
		<Breadcrumbs sx={{ fontSize:'12px' }} p="20px 0px" separator={<ChevronRight className="orange_cl" sx={{ fontSize: 12 }}/>}>{breads}</Breadcrumbs>
	);
};

// STEP BY STEP GUIDE SECTION
export const StepsByStep=(stepInfo)=>{
	return( 
		<Box display="flex" justifyContent="center" alignItems="center" gap={10} className="mb_25 pro_buy_steps">
			{stepInfo.steps.map((step, index) => (
				<Box key={index} textAlign="center" position="relative" justifyItems="center" sx={{ width: 180 }}>
					{index !== 0 && (
						imageExist({
							required : '/common',
							url      : index % 2 === 0 ? '/arrow-step-2.png' : '/arrow-step-1.png',
							alt      : 'step-arrow',
							style    : {
								position: 'absolute',
								left: '-112px',
								top: index % 2 === 0 ? '26%' : '35%',
								transform: 'translateY(-50%)',
								width: '142px',
								height: 'auto'
							}
						}) 
					)}
					<Box
						sx={{
							width: 90,
							height: 90,
							backgroundColor: '#051027',
							borderRadius: '50%',
							justifyItems:'center',
							alignSelf:'center',
							padding: '5px',
							boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
							marginBottom:'16px'
						}}
					>
						<Box
							sx={{
								width: '85px',
								height: '85px',
								borderRadius: '50%',
								border: '1.7px dashed white',
								alignContent:'center'
							}}
						>
							<Typography color="white" fontWeight={600} fontSize={14}>{step.label}</Typography>
						</Box>
					</Box>
					<Typography sx={{ fontSize:'14px !important' }} className='blue_cl' minWidth="231px" lineHeight={'20px'}>{step.description}</Typography>
				</Box>
			))}
		</Box>
	);
};







